/**
 * This code was generated by Builder.io.
 */
import React from "react";

interface InputFieldProps {
  label: string;
  value: string;
  id: string;
  type: string;
  placeholder: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean
  width?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  id,
  onChange,
  placeholder,
  type,
  value,
  disabled,
  width = "w-full",
}) => {
  return (
    <div className={`flex flex-col ${width} whitespace-nowrap rounded mb-2`}>
      <label htmlFor={label.toLowerCase()} className="self-start">
        {label}
      </label>
      <input
        value={value}
        id={id}
        type={type}
        className={disabled ? "flex shrink-0 mt-2 rounded-l border border-gray-300 outline-none border-solid h-[32px] pl-1 text-[14px] font-sans font-semibold text-black disabled:opacity-70 bg-[#ddd]": " flex shrink-0 mt-2 bg-white rounded-l border border-gray-300 outline-none border-solid h-[32px] pl-1 text-[14px] font-sans font-semibold text-black"}
        aria-label={label}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
      />
    </div>
  );
};

export default InputField;
